export var name = "@atlaskit/editor-core";
export var version = "207.0.1";